var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app",staticStyle:{"height":"auto"}},[(_vm.$store.state.loader)?_c('Loader'):_vm._e(),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }